import React from 'react';
import { ClipboardList, Users, Activity, BookOpen, Smile, Sparkles } from 'lucide-react';
export function ProgramsSection() {
  const programs = [{
    icon: <ClipboardList className="w-6 h-6 text-azul" data-id="element-190" />,
    title: 'Evaluación y diagnóstico personalizado',
    text: 'Sesiones para conocer la situación actual de cada persona y establecer objetivos claros.'
  }, {
    icon: <Users className="w-6 h-6 text-azul" data-id="element-191" />,
    title: 'Acompañamiento individual y familiar',
    text: 'Apoyo terapéutico uno a uno y orientación para seres queridos.'
  }, {
    icon: <Activity className="w-6 h-6 text-azul" data-id="element-192" />,
    title: 'Trabajo emocional y físico',
    text: 'Procesos orientados a preparar a la persona para nuevas etapas de bienestar.'
  }, {
    icon: <BookOpen className="w-6 h-6 text-azul" data-id="element-193" />,
    title: 'Educación y herramientas preventivas',
    text: 'Talleres para comprender conductas y adoptar estrategias para prevenir retrocesos.'
  }, {
    icon: <Smile className="w-6 h-6 text-azul" data-id="element-194" />,
    title: 'Actividades recreativas para el bienestar',
    text: 'Espacios grupales, actividades recreativas, deporte y reflexión.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-azul" data-id="element-195" />,
    title: 'Enfoque terapéutico holístico',
    text: 'Combinación de prácticas tradicionales y complementarias para abordar cuerpo y mente.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-196">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="text-center mb-16" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-bold text-azul" data-id="element-199">
            Nuestros programas y modalidades
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-200">
          {programs.map((program, index) => <div key={index} className="bg-graySoft p-8 rounded-2xl border border-gray-100 hover:shadow-md transition-shadow" data-id="element-201">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-sm mb-6" data-id="element-202">
                {program.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-203">
                {program.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-204">{program.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}